import { Outlet } from "react-router-dom";
import {ToastContainer } from 'react-toastify';
import { PageMask } from "./PageMask";
import 'react-toastify/dist/ReactToastify.css';

export function App() {    
    return <div style={{ height: "100vh" }}>
        <div id="content">
            <ToastContainer /> 
            <PageMask />
            <Outlet />
        </div>
    </div>;
}